// Icônes des 4 applications SCADA, réutilisées dans le Kanban et la Chronologie.
export const APP_ICONS = {
  reservoir: '💧',
  barriere: '🚧',
  feu_tricolore: '🚦',
  surveillance: '📹',
};

export const getAppIcon = (application) => APP_ICONS[application] || '⚙️';